import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {flexCenter} from '../../../../../libs/shared/ui/src/styles/mixins';
import {openInBrowser} from '../../../../../srcCommon/browser/openInBrowser';
import {Skeleton, SkeletonColorSchemesEnum} from '../../../../components/common/skeleton';
import {helpCenterUrl} from '../../../../store/stateless/navigationActions';
import {StyledFlex} from '../../reportViewer/reportCommons';
import {ReportGridItem} from '../../reportViewer/reportGrid';

/*
 * Style.
 */

const StyledInfoDiv = styled.div`
  padding: 30px 30px 20px 30px;
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.small};
  color: ${(p) => p.theme.greys.shade70};
  text-align: center;
`;

const StyledButtonContent = styled(StyledFlex)`
  justify-content: center;
`;

const StyledButton = styled(Button)`
  ${flexCenter}
  justify-content: center;
  margin-top: 8px;
`;

const StyledIcon = styled(Icon)`
  margin-left: 4px;
`;

/*
 * Props.
 */

export interface ExportInfoTextProps {
  text: ReactNode;
  subtext: ReactNode;
  helpLink?: string;
  isLoading?: boolean;
}

/*
 * Component.
 */

export const ExportInfoText: FC<ExportInfoTextProps> = ({isLoading, text, subtext, helpLink}) => {
  if (isLoading) {
    return renderLoadingState();
  }

  return (
    <StyledInfoDiv>
      {text}

      <StyledButton
        variant={ButtonVariantsEnum.LINK}
        size={VisualSizesEnum.SMALL}
        onClick={() => openInBrowser(helpLink ?? `${helpCenterUrl}/t/q57yxg/export-of-analytics`)}
      >
        <StyledButtonContent>
          {subtext}
          <StyledIcon name="externalLinkSmall" />
        </StyledButtonContent>
      </StyledButton>
    </StyledInfoDiv>
  );
};

/*
 * Helpers.
 */

function renderLoadingState() {
  return (
    <StyledInfoDiv>
      <ReportGridItem>
        <Skeleton width="80%" height="11px" borderRadius="4px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </ReportGridItem>
      <ReportGridItem>
        <Skeleton width="20%" height="11px" borderRadius="4px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </ReportGridItem>
      <ReportGridItem>
        <Skeleton width="40%" height="11px" borderRadius="4px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </ReportGridItem>
    </StyledInfoDiv>
  );
}
